import { render, staticRenderFns } from "./PrizeCategoryTable.vue?vue&type=template&id=4461b5f0&"
import script from "./PrizeCategoryTable.vue?vue&type=script&lang=js&"
export * from "./PrizeCategoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports